import { create } from 'zustand';

// Load initial searchList from localStorage if available
const getInitialSearchList = () => {
    const storedList = localStorage.getItem('searchList');
    return storedList ? JSON.parse(storedList) : [];
};

const useNavbarSearchStore = create((set) => ({
    searchList: getInitialSearchList(),
    setSearchList: (newList) => {
        // Sort the newList before saving it
        const sortedList = [...newList].sort((a, b) => a.name.localeCompare(b.name));
        set(() => ({ searchList: sortedList }));
        localStorage.setItem('searchList', JSON.stringify(sortedList));
    },

    clearSearchList: () => {
        set(() => ({ searchList: [] }));
        localStorage.removeItem('searchList');
    },
}));

export default useNavbarSearchStore;